/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthEmailControllerAuthorizeByEmailMutationRequest,
  TelegramAuthEmailControllerAuthorizeByEmailMutationResponse,
  TelegramAuthEmailControllerAuthorizeByEmail401,
  TelegramAuthEmailControllerAuthorizeByEmail403,
} from '../../types/TelegramAuthEmailControllerAuthorizeByEmail.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthEmailAuthorizeByEmail } from '../../methods/telegramAuthEmailAuthorizeByEmail.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthEmailAuthorizeByEmailMutationKey = () => [{ url: '/api/telegram/auth/email/login' }] as const;

export type TelegramAuthEmailAuthorizeByEmailMutationKey = ReturnType<
  typeof telegramAuthEmailAuthorizeByEmailMutationKey
>;

/**
 * {@link /api/telegram/auth/email/login}
 */
export function useTelegramAuthEmailAuthorizeByEmail<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthEmailControllerAuthorizeByEmailMutationResponse,
      ResponseErrorConfig<
        TelegramAuthEmailControllerAuthorizeByEmail401 | TelegramAuthEmailControllerAuthorizeByEmail403
      >,
      { data: TelegramAuthEmailControllerAuthorizeByEmailMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthEmailControllerAuthorizeByEmailMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthEmailAuthorizeByEmailMutationKey();

  return useMutation<
    TelegramAuthEmailControllerAuthorizeByEmailMutationResponse,
    ResponseErrorConfig<
      TelegramAuthEmailControllerAuthorizeByEmail401 | TelegramAuthEmailControllerAuthorizeByEmail403
    >,
    { data: TelegramAuthEmailControllerAuthorizeByEmailMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthEmailAuthorizeByEmail(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
